import {
  ArrowLeftOutlined,
  ArrowUpOutlined,
  CheckCircleFilled,
} from "@ant-design/icons";
import {
  AutoComplete,
  Breadcrumb,
  Button,
  Card,
  Col,
  Divider,
  FloatButton,
  Form,
  Input,
  Row,
  Select,
  Space,
  Typography,
  theme,
} from "antd";
import React, { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Heading from "../../../components/common/heading";
import FailModal from "../../../components/modal/failModal";
import SuccessModal from "../../../components/modal/successModal";
import useCancelModal from "../../../lib/hooks/useCancelModal";
import useEState from "../../../lib/hooks/useEState";
import useInstitution from "../../../lib/hooks/useInstitution";
import useLineOfWork from "../../../lib/hooks/useLineOfWork";
import usePosition from "../../../lib/hooks/usePosition";
import useQuarter from "../../../lib/hooks/useQuarter";
import useStaffName from "../../../lib/hooks/useStaffName";
import useTouchpoint from "../../../lib/hooks/useTouchpoint";
import { routes } from "../../../routes";
import {
  createTouchPointPage,
  editTouchPointPage,
  getChanel,
  getDetailTouchPointPage,
} from "../../../services/customerTouchPoint";
import WithSidebar from "../../../templates/withSidebar";
import Validation, { channelList } from "./components/dataReport";
import {MultipleAutoComplete} from "../../../components/common/autoCompleteV2";

const { useToken } = theme;

const { Text, Link } = Typography;
const { Option } = Select;

export const AddTouchPoint = () => {
  const { questionValues, headerValues, setHeaderValues } = useTouchpoint();
const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const { token } = useToken();
  const [quarter] = useQuarter();
  const [estate] = useEState();
  const [lineOfWork] = useLineOfWork();
  const [position] = usePosition();
  const [staffName] = useStaffName();
  const [institution] = useInstitution();
  const [form] = Form.useForm();
  const { openCancelModal, setOpenCancelModal, previousPage, setPreviousPage } =
    useCancelModal();
  const [qaList, setQaList] = useState([]);
  const [agencyType, setAgencyType] = useState("");
  const [agencyChannel, setAgencyChannel] = useState("");
  const [actionType, setActionType] = useState(
    location.state.action_type ? location.state.action_type : ""
  );


  const [vocData, setVocData] = useState({});

  const [DisableMode, setDisableMode] = useState(false);
  const [quarterValue, setQuarterValue] = useState("");
  const [nameReporter, setNameReporter] = useState("");
  const [telReporter, setTelReporter] = useState("");
  const [positionReporter, setPositionReporter] = useState("");
  const [namelineOfWork, setNameLineOfWork] = useState("");
  const [nameIndustrial, setNameIndustrial] = useState("");
  const [bufferData, setbufferData] = useState([]);
  const [successModal, setSuccessModal] = useState(false);
  const [failModal, setFailModal] = useState(false);
  const [dataRecord, setDataRecord] = useState(
    location.state.dataRecord ? location.state.dataRecord : ""
  );
  const [editID, setEditID] = useState(
    location.state.edit_id ? location.state.edit_id : ""
  );
  const [chkData, setChkData] = useState(
    location.state.status_data ? location.state.status_data : ""
  );

  const values = Form.useWatch([], form);
  const [submittable, setSubmittable] = useState(true);
  const [factoryName, setFactoryName] = useState("");

  const onChangePage = () => {
    setOpenCancelModal(true);
  };

  // เลือกหน่วนงาน
  const onChangeInst = (value) => {
    getChanelData(value);
    setAgencyType(value);

    if (value != "032b6473-4b60-ecc1-d97d-893e36a8e43b") {
    }
  };
  // เลือกไตรมาศ
  const onChangeQuarter = (value) => {
    setQuarterValue(value);
  };

  // เลือกอุตสหกรรม
  const onChangeIndustrialName = (value) => {
    setNameIndustrial(value);
  };
  // เลือกอสายงาน
  const onChangeLineOfWork = (value) => {
    setNameLineOfWork(value);
  };

  //เลือกตำแหน่ง
  const onSelectPosition = (value, option) => {
    setPositionReporter(option);
  };
  //เลือกชื่อนามสกุล
  const onSelectName = (value, option) => {
    setNameReporter(option);
  };
  //เบอร์ติดต่อผู้รายงาน
  const onChangeTelReporter = (e) => {
    setTelReporter(e.target.value);
  };
  // ชื่อโรงงาน
  const onChangeFactoryName = (e) => {
    setFactoryName(e.target.value);
  };

  //get ข้อมูลแบบสอบถาม touchpoint
  const getChanelData = useCallback(
    async (value) => {
      const res = await getChanel(value);

      if (res.data.code === "0000") {
        setQaList(res.data.objectValue);
      }
    },
    [agencyChannel]
  );

  const onFinish = async (values) => {
    let fieldValue = form.getFieldsValue(true);
    
    //prepare data question from localStorage
    setbufferData([]);
    const quarterBuff = values.quarter.split("/");
    channelList.map((item) => {
      let buff = JSON.parse(localStorage.getItem(item));
      if (buff != null) {
         //console.log("buff.vocDetail===>");
         //console.log(JSON.stringify(buff.vocDetail));
         let vocDetail = buff.vocDetail;
        buff.questionDetail.map((data) => {
          console.log("data==>>");
          console.log(data);
          data.vocDetail = vocDetail;
          bufferData.push(data);
        });
      }
      
    });
    
    if (actionType === "CREATE") {

      
      //CREATE
      if (
        (fieldValue.position_reporter.value
          ? fieldValue.position_reporter.value.trim() !== ""
          : fieldValue.position_reporter !== "") &&
        (fieldValue.name_reporter.value
          ? fieldValue.name_reporter.value.trim() !== ""
          : fieldValue.name_reporter !== "") &&
        positionReporter !== "" &&
        nameReporter !== "" &&
        positionReporter !== undefined &&
        nameReporter !== undefined
      ) {
        let requestbody = {
          requestObject: {
            institutionId: agencyType,
            lineOfWorkId: fieldValue.line_of_work
              ? fieldValue.line_of_work
              : "",
            estateId: fieldValue.industrial_name
              ? fieldValue.industrial_name
              : "",
            name: nameReporter.value ? nameReporter.value : nameReporter,
            positionName: positionReporter.value
              ? positionReporter.value
              : positionReporter,
            phone: fieldValue.tel_reporter,
            quarterOfBudget: quarterBuff[0],
            yearOfBudget: quarterBuff[1],
            answerDetailList: bufferData,
            factoryName: fieldValue.factoryName,
          },
        };
      
        console.log("===CREATE===");
        console.log(requestbody);
        if (bufferData.length > 0) {
          try {
            const res = await createTouchPointPage(requestbody, agencyType);
            if (res.data.code === "0000") {
              setSuccessModal(true);
              setTimeout(() => {
                navigate(routes.customer_tab_touchpoint, {
                  state: {},
                });
              }, 1000);
            } else {
              if (
                res.data.code === "ERR-0022" &&
                res.data.message === "Data duplicate."
              ) {
                form.setFields([
                  {
                    name: "quarter",
                    errors: ["รายการนี้มีในระบบแล้ว รบกวนทำรายการใหม่อีกครั้ง"],
                  },
                ]);
                form.setFields([
                  {
                    name: "agency",
                    errors: ["รายการนี้มีในระบบแล้ว รบกวนทำรายการใหม่อีกครั้ง"],
                  },
                ]);
              } else {
                setFailModal(true);
              }
            }
          } catch (error) {
            // console.log(error);
          }
          form.setFields([
            {
              name: "card_answer",
              errors: [""],
            },
          ]);
        } else {
          form.setFields([
            {
              name: "card_answer",
              errors: ["กรุณาเลือกอย่างน้อย 1 Touchpoint"],
            },
          ]);
        }
      } else {
        if (
          fieldValue.position_reporter.trim() === "" ||
          positionReporter === "" ||
          positionReporter === undefined
        ) {
          form.setFields([
            {
              name: "position_reporter",
              errors: ["โปรดระบุ"],
              value: "",
            },
          ]);
        }
        if (
          fieldValue.name_reporter.trim() === "" ||
          nameReporter === "" ||
          nameReporter === undefined
        ) {
          form.setFields([
            {
              name: "name_reporter",
              errors: ["โปรดระบุ"],
              value: "",
            },
          ]);
        }
      }

      //  console.log(requestbody);

      //check answer more than 1 touchpoint
    } else {
      //EDIT
      let dataAns = [];
      console.log("===EDIT===");
      bufferData.map((item) => {
        dataAns.push({
          questionId: item.questionId,
          channel: item.channel,
          answer: item.answer,
          vocDetail: item.vocDetail
        });
      });
      //dataAns.push("vocDetail",vocDetail);
      if (
        fieldValue.position_reporter.trim() !== "" &&
        fieldValue.name_reporter.trim() !== "" &&
        positionReporter !== "" &&
        nameReporter !== ""
      ) {
        const foundPosition = position.find(
          (element) => element.value == fieldValue.position_reporter.trim()
        );
        const foundNameReporter = staffName.find(
          (element) => element.value == fieldValue.name_reporter.trim()
        );

        if (foundPosition !== undefined && foundNameReporter !== undefined) {
          let requestbody = {
            requestObject: {
              id: dataRecord.touchPointAnswerId
                ? dataRecord.touchPointAnswerId
                : editID,
              institutionId: values.agency ? values.agency : "",
              lineOfWorkId: values.line_of_work ? values.line_of_work : "",
              estateId: values.industrial_name ? values.industrial_name : "",
              name: nameReporter.value,
              positionName: positionReporter.value,
              phone: values.tel_reporter,
              quarterOfBudget: quarterBuff[0],
              yearOfBudget: quarterBuff[1],
              answerDetailList: dataAns,
              factoryName: fieldValue.factoryName,
              
            },
          };
          console.log(requestbody);
          try {
            const res = await editTouchPointPage(requestbody, agencyType);

            if (res.data.code === "0000") {
              setSuccessModal(true);

              setTimeout(() => {
                navigate(routes.customer_tab_touchpoint, {
                  state: {},
                });
              }, 1000);
            } else {
              setFailModal(true);
            }
          } catch (error) {
            // console.log(error);
          }
        } else {
          if (foundPosition === undefined) {
            form.setFields([
              {
                name: "position_reporter",
                errors: ["โปรดระบุ"],
                value: "",
              },
            ]);
          }
          if (foundNameReporter === undefined) {
            form.setFields([
              {
                name: "name_reporter",
                errors: ["โปรดระบุ"],
                value: "",
              },
            ]);
          }
        }
      } else {
        if (
          fieldValue.position_reporter.trim() === "" ||
          positionReporter === ""
        ) {
          form.setFields([
            {
              name: "position_reporter",
              errors: ["โปรดระบุ"],
              value: "",
            },
          ]);
        }
        if (fieldValue.name_reporter.trim() === "" || nameReporter === "") {
          form.setFields([
            {
              name: "name_reporter",
              errors: ["โปรดระบุ"],
              value: "",
            },
          ]);
        }
      }
    }
  };
  const getDetail = useCallback(async () => {
    const vocMap = {};
    const res = await getDetailTouchPointPage(
      dataRecord.touchPointAnswerId ? dataRecord.touchPointAnswerId : editID
    );

    
      console.log("Add Page getDetailTouchPointPage =res.data.objectValue =>");
      console.log(res.data.objectValue);

    if (res.data.code === "0000") {
      setDisableMode(true);

      const result = res.data.objectValue;

      setAgencyType(result.institutionId);
      getChanelData(result.institutionId);
      setQuarterValue(result.quarterOfBudget + "/" + result.yearOfBudget);
      setPositionReporter(result.positionName);
      setNameReporter(result.name);
      setEditID(result.id);
      setFactoryName(result.factoryName);
      form.setFieldsValue({
        quarter: result.quarterOfBudget + "/" + result.yearOfBudget,
        agency: result.institutionId,
        industrial_name: result.estateId,
        line_of_work: result.lineOfWorkId,
        name_reporter: result.name,
        position_reporter: result.positionName,
        tel_reporter: result.phone,
        factoryName: result.factoryName,
      });
      //set header context

      setHeaderValues({
        id: result.id,
        quarter: result.quarterOfBudget + "/" + result.yearOfBudget,
        agency: result.institutionId,
        industrial_name: result.estateId,
        line_of_work: result.lineOfWorkId,
        name_reporter: result.name,
        position_reporter: result.positionName,
        tel_reporter: result.phone,
        factoryName: result.factoryName,
      });

      if (chkData === "not_avilable_data" || chkData === "") {
        channelList.map((channelName) => {
          const resultX = result.answerDetailResponseList.filter((item) => {
            return item.channel === channelName;
          });
          //  const result_voc = result.vocDetail.filter((item) => {
          //   return item.channel === channelName;
          // });
          if (resultX.length > 0) {
            vocMap[channelName] = resultX[0].vocDetail;
            localStorage.setItem(
              channelName,
              JSON.stringify({
                agencyType: result.institutionId,
                agencyChannel: channelName,
                //  questionID: resultX[0].questionId.substring(0, 6),
                questionDetail: resultX,
                vocDetail: resultX[0].vocDetail
              })
            );
          }
          
        });
        setVocData(vocMap);
        console.log("vocMap===>");
        console.log(vocMap);
      }
    } else {
      setFailModal(true);
      setTimeout(() => {
        navigate(routes.customer_tab_touchpoint, {
          state: {},
        });
      }, 1000);
    }
  }, [form]);

  //set defualt value กรณี บันทึกแบบสอบถามแล้วกลับมาหน้า add
  const setValueDefualt = () => {
    if (headerValues.agency != undefined) {
      setQuarterValue(headerValues.quarter);
      setNameReporter(headerValues.name_reporter);
      setPositionReporter(headerValues.position_reporter);
      setTelReporter(headerValues.tel_reporter);
      setNameIndustrial(headerValues.industrial_name);
      setNameLineOfWork(headerValues.line_of_work);
      setAgencyType(headerValues.agency);
      getChanelData(headerValues.agency);
      setFactoryName(headerValues.factoryName);

      form.setFieldsValue({
        quarter: headerValues.quarter,
        agency: Validation.convertInst(headerValues.agency),
        name_reporter: headerValues.name_reporter,
        position_reporter: headerValues.position_reporter,
        tel_reporter: headerValues.tel_reporter,
        line_of_work: headerValues.line_of_work,
        industrial_name: headerValues.industrial_name,
        factoryName: headerValues.factoryName,
      });
    } else {
      //form.resetFields();
    }
  };

  useEffect(() => {
    if (actionType === "EDIT") {
      getDetail();
    } else {
      setValueDefualt();
    }
  }, []);

  useEffect(() => {
    form.setFields([
      {
        name: "card_answer",
        value: "card_answer",
      },
    ]);

    form
      .validateFields({
        validateOnly: true,
      })
      .then(
        () => {
          setSubmittable(false);
        },
        () => {
          setSubmittable(true);
        }
      );
  }, [values]);

  return (
    <WithSidebar>
      <div>
        <Row gutter={[24, 24]} style={{ marginTop: 15 }}>
          <Col span={24}>
            <div className="flex items-center">
              <Space size={12}>
                <Button
                  type="link"
                  onClick={() => {
                    setOpenCancelModal(true);
                    setPreviousPage(routes.customer_tab_touchpoint);
                  }}
                  style={{ padding: 0 }}
                >
                  <ArrowLeftOutlined style={{ color: "#000", fontSize: 16 }} />
                </Button>
                <Heading text={"รายละเอียด"} size={4} style={{ margin: 0 }} />
              </Space>
            </div>
            <Breadcrumb
              style={{ paddingTop: 10 }}
              items={[
                {
                  title: "คลังข้อมูล Touch point ",
                },
                {
                  title: (
                    <span onClick={onChangePage} style={{ cursor: "pointer" }}>
                      รายละเอียด
                    </span>
                  ),
                },
              ]}
            />
          </Col>

          <Col span={24}>
            <Form
              name="validateOnly"
              form={form}
              onFinish={onFinish}
              layout="vertical"
              style={{ width: "100%", padding: "0 30px" }}
              autoComplete="off"
            >
              <Row gutter={[24, 16]} style={{ marginBottom: 10 }}>
                <Col span={24} align="right">
                  <Space>
                    <Button
                      onClick={() => {
                        setOpenCancelModal(true);
                        setPreviousPage(routes.customer_tab_touchpoint);
                      }}
                    >
                      ยกเลิก
                    </Button>
                    <Button type="primary" htmlType="submit">
                      บันทึก
                    </Button>
                  </Space>
                </Col>
              </Row>
              <Row gutter={[8, 16]} className="card">
                <Col span={24}>
                  <Heading
                    text={"ข้อมูลแบบสอบถาม"}
                    size={4}
                    style={{ margin: 0, color: token.thPrimary }}
                  />
                  <Divider />
                </Col>

                <Col span={16}>
                  <Row gutter={[8, 16]}>
                    <Col span={12}>
                      <Form.Item
                        label="ไตรมาส"
                        name={"quarter"}
                        rules={[
                          {
                            required: true,
                            message: "โปรดระบุ",
                          },
                        ]}
                      >
                        <Select
                          allowClear
                          showSearch={false}
                          className="w-full"
                          placeholder="กรุณาเลือก"
                          optionFilterProp="children"
                          onChange={onChangeQuarter}
                          hasfeedback="true"
                          disabled={DisableMode}
                        >
                          {quarter.map((item, i) => {
                            return (
                              <Option key={i} value={item}>
                                {item}
                              </Option>
                            );
                          })}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        label="เลือกหน่วยงาน"
                        name={"agency"}
                        rules={[
                          {
                            required: true,
                            message: "โปรดระบุ",
                          },
                        ]}
                      >
                        <Select
                          allowClear
                          showSearch={false}
                          className="w-full"
                          placeholder="กรุณาเลือก"
                          optionFilterProp="children"
                          onChange={onChangeInst}
                          value={agencyType}
                          disabled={DisableMode}
                        >
                          {institution.map((item, i) => {
                            return (
                              <Option key={i} value={item.id}>
                                {item.institutionNameTh}
                              </Option>
                            );
                          })}
                        </Select>
                      </Form.Item>
                    </Col>
                  </Row>
                </Col>
                {Validation.convertInst(agencyType) ===
                  "สำนักงานนิคมอุตสาหกรรม" && (
                  <>
                    <Col span={16}>
                      <Row gutter={[8, 16]}>
                        <Col span={12}>
                          <Form.Item
                            label="ชื่อนิคมอุตสาหกรรม"
                            name={"industrial_name"}
                            rules={[
                              {
                                required: true,
                                message: "โปรดระบุ",
                              },
                            ]}
                          >
                            {/* <Select
                              allowClear
                              showSearch={false}
                              className="w-full"
                              placeholder="กรุณาเลือก"
                              optionFilterProp="children"
                              onChange={onChangeIndustrialName}
                              hasfeedback="true"
                              disabled={DisableMode}
                            >
                              {estate.map((item, i) => {
                                return (
                                  <Option key={i} value={item.estateId}>
                                    {item.estateNameTh}
                                  </Option>
                                );
                              })}
                            </Select> */}
                            <MultipleAutoComplete
                                multiple={false}
                                subject="estateName"
                                valueField="estateId"
                                labelField="estateNameTh"
                                placeholder="กรุณาเลือก"
                                onChange={onChangeIndustrialName}
                                disabled={DisableMode}
                              />
                          </Form.Item>
                        </Col>
                        <Col span={12}>
                          <Form.Item
                            label="สายงาน"
                            name={"line_of_work"}
                            rules={[
                              {
                                required: true,
                                message: "โปรดระบุ",
                              },
                            ]}
                          >
                            <Select
                              allowClear
                              showSearch={false}
                              className="w-full"
                              placeholder="กรุณาเลือก"
                              optionFilterProp="children"
                              onChange={onChangeLineOfWork}
                              hasfeedback="true"
                              disabled={DisableMode}
                            >
                              {lineOfWork.map((item, i) => {
                                return (
                                  <Option key={i} value={item.lineOfWork}>
                                    {item.nameTh}
                                  </Option>
                                );
                              })}
                            </Select>
                          </Form.Item>
                        </Col>
                      </Row>
                    </Col>
                  </>
                )}
                {agencyType && agencyType != "" && (
                  <>
                    <Divider />

                    <Card style={{ width: "80%" }}>
                      <Form.Item name={"card_answer"}>
                        <Heading
                          text={"เลือก Touch Point เพื่อทำแบบสอบถาม"}
                          size={4}
                          style={{ margin: "0px 0px 10px 0px" }}
                        />
                        {qaList.map((item, index) => {
                          let chkFlag = JSON.parse(
                            localStorage.getItem(item.channel)
                          );

                          return (
                            <>
                              <Row key={index} style={{ paddingBottom: 10 }}>
                                <Col span={18}>
                                  <Link
                                    key={item.institutionId}
                                    onClick={() => {
                                      if (actionType === "EDIT") {
                                        {
                                          chkFlag != null ? (
                                            <>
                                              {navigate(
                                                routes.view_customer_touchpoint_page,
                                                {
                                                  state: {
                                                    agency_type:
                                                      item.institutionId,
                                                    agency_name: item.header,
                                                    agency_detail: JSON.parse(
                                                      localStorage.getItem(
                                                        item.channel
                                                      )
                                                    ),
                                                    agency_channel:
                                                      item.channel,
                                                    action_type: actionType,
                                                    agency_header:
                                                      item.headerDetail,
                                                    status_data:
                                                      "avilable_data",
                                                    header: [
                                                      {
                                                        id: dataRecord.touchPointAnswerId
                                                          ? dataRecord.touchPointAnswerId
                                                          : editID,
                                                        agency: agencyType,
                                                        quarter: quarterValue,
                                                        line_of_work:
                                                          namelineOfWork,
                                                        industrial_name:
                                                          nameIndustrial,
                                                        name_reporter:
                                                          nameReporter ? nameReporter.value ? nameReporter.value : nameReporter : "",
                                                        position_reporter:
                                                          positionReporter,
                                                        tel_reporter:
                                                          telReporter,
                                                        factoryName:
                                                          factoryName,
                                                      },
                                                    ],
                                                  },
                                                }
                                              )}
                                            </>
                                          ) : (
                                            <>
                                              {navigate(
                                                routes.add_customer_touchpoint_page,
                                                {
                                                  state: {
                                                    agency_type:
                                                      item.institutionId,
                                                    agency_name: item.header,
                                                    voc_detail: vocData,
                                                    agency_detail: JSON.parse(
                                                      localStorage.getItem(
                                                        item.channel
                                                      )
                                                    ),
                                                    agency_channel:
                                                      item.channel,
                                                    agency_header:
                                                      item.headerDetail,
                                                    action_type: actionType,
                                                    status_data:
                                                      "not_avilable_data",
                                                    header: [
                                                      {
                                                        id: dataRecord.touchPointAnswerId
                                                          ? dataRecord.touchPointAnswerId
                                                          : editID,
                                                        agency: agencyType,
                                                        quarter: quarterValue,
                                                        line_of_work:
                                                          namelineOfWork,
                                                        industrial_name:
                                                          nameIndustrial,
                                                        name_reporter:
                                                          nameReporter ? nameReporter.value ? nameReporter.value : nameReporter : "",
                                                        position_reporter:
                                                          positionReporter,
                                                        tel_reporter:
                                                          telReporter,
                                                        factoryName:
                                                          factoryName,
                                                      },
                                                    ],
                                                  },
                                                }
                                              )}
                                            </>
                                          );
                                        }
                                      } else {
                                        {
                                          chkFlag != null ? (
                                            <>
                                              {navigate(
                                                routes.view_customer_touchpoint_page,
                                                {
                                                  state: {
                                                    agency_type:
                                                      item.institutionId,
                                                    agency_name: item.header,
                                                    agency_detail: JSON.parse(
                                                      localStorage.getItem(
                                                        item.channel
                                                      )
                                                    ),
                                                    agency_channel:
                                                      item.channel,
                                                    agency_header:
                                                      item.headerDetail,
                                                    action_type: actionType,
                                                    header: [
                                                      {
                                                        agency: agencyType,
                                                        quarter: quarterValue,
                                                        line_of_work:
                                                          namelineOfWork,
                                                        industrial_name:
                                                          nameIndustrial,
                                                        name_reporter:
                                                          nameReporter ? nameReporter.value ? nameReporter.value : nameReporter : "",
                                                        position_reporter:
                                                          positionReporter,
                                                        tel_reporter:
                                                          telReporter,
                                                        factoryName:
                                                          factoryName,
                                                      },
                                                    ],
                                                  },
                                                }
                                              )}
                                            </>
                                          ) : (
                                            <>
                                              {navigate(
                                                routes.add_customer_touchpoint_page,
                                                {
                                                  state: {
                                                    agency_type:
                                                      item.institutionId,
                                                    agency_name: item.header,
                                                    agency_detail: JSON.parse(
                                                      localStorage.getItem(
                                                        item.channel
                                                      )
                                                    ),
                                                    agency_channel:
                                                      item.channel,
                                                    agency_header:
                                                      item.headerDetail,
                                                    action_type: actionType,
                                                    header: [
                                                      {
                                                        agency: agencyType,
                                                        quarter: quarterValue,
                                                        line_of_work:
                                                          namelineOfWork,
                                                        industrial_name:
                                                          nameIndustrial,
                                                        name_reporter:
                                                          nameReporter ? nameReporter.value ? nameReporter.value : nameReporter : "",
                                                        position_reporter:
                                                          positionReporter,
                                                        tel_reporter:
                                                          telReporter,
                                                        factoryName:
                                                          factoryName,
                                                      },
                                                    ],
                                                  },
                                                }
                                              )}
                                            </>
                                          );
                                        }
                                      }
                                    }}
                                    underline
                                  >
                                    {actionType === "EDIT"
                                      ? item.header
                                      : item.header}
                                  </Link>
                                </Col>
                                {chkFlag != null ? (
                                  <Col span={6}>
                                    <CheckCircleFilled
                                      style={{
                                        paddingRight: 5,
                                        color: "#4ACE8F",
                                      }}
                                    />
                                    ทำแบบสอบถามเรียบร้อยแล้ว
                                  </Col>
                                ) : (
                                  <Col span={6}>
                                    <CheckCircleFilled
                                      style={{ paddingRight: 5, color: "gray" }}
                                    />
                                    ยังไม่ได้ทำแบบสอบถาม
                                  </Col>
                                )}
                              </Row>
                            </>
                          );
                        })}
                      </Form.Item>
                    </Card>

                    <Col span={24}>
                      <Heading
                        text={"ข้อมูลแบบสอบถาม"}
                        size={4}
                        style={{ margin: 0, color: token.thPrimary }}
                      />
                    </Col>
                    <Col span={16}>
                      <Form.Item
                        label={"ชื่อ-นามสกุลผู้รายงาน"}
                        name={"name_reporter"}
                        rules={[
                          {
                            required: true,
                            message: "โปรดระบุ",
                          },
                        ]}
                      >
                        <AutoComplete
                          optionLabelProp="value"
                          onSelect={onSelectName}
                          filterOption={true}
                          placeholder="ชื่อ-นามสกุลผู้รายงาน"
                        >
                          {staffName.map((item) => {
                            return (
                              <>
                                <Option key={item.id} value={item.value}>
                                  <Text>{item.value}</Text>
                                </Option>
                              </>
                            );
                          })}
                        </AutoComplete>
                      </Form.Item>
                    </Col>
                    <Col span={16}>
                      <Row gutter={[8, 16]}>
                        <Col span={12}>
                          <Form.Item
                            label="ตำแหน่งผู้รับรายงาน"
                            name={"position_reporter"}
                            rules={[
                              {
                                required: true,
                                message: "โปรดระบุ",
                              },
                            ]}
                          >
                            <AutoComplete
                              options={position}
                              style={{ width: 200 }}
                              onSelect={onSelectPosition}
                              filterOption={true}
                              placeholder="ตำแหน่งผู้รับรายงาน"
                            />
                          </Form.Item>
                        </Col>
                        <Col span={12}>
                          <Form.Item
                            label="เบอร์ติดต่อผู้รายงาน"
                            name={"tel_reporter"}
                            rules={[
                              {
                                required: true,
                                message: "โปรดระบุ",
                              },
                              {
                                pattern: new RegExp(/([0-9])/g),
                                message: "โปรดระบุ",
                              },
                            ]}
                          >
                            <Input
                              placeholder={"Ex.080-000-0000"}
                              maxLength={12}
                              min={0}
                              style={{ width: "100%" }}
                              onChange={onChangeTelReporter}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                    </Col>
                    {/* <Col span={16}>
                      <Form.Item
                        label="ชื่อโรงงาน"
                        name={"factoryName"}
                        rules={[
                          {
                            required: true,
                            message: "โปรดระบุ",
                          },
                        ]}
                      >
                        <Input placeholder="" onChange={onChangeFactoryName} />
                      </Form.Item>
                    </Col> */}
                  </>
                )}
              </Row>
            </Form>
          </Col>
        </Row>
      </div>
      <SuccessModal
        open={successModal}
        setOpen={setSuccessModal}
        title={"สำเร็จ"}
        subTitle={"ทำรายการสำเร็จ"}
      />
      <FailModal
        open={failModal}
        setOpen={setFailModal}
        title={"มีบางอย่างผิดพลาด"}
        setErrMsg={setErrorMessage}
        subTitle={"มีบางอย่างผิดพลาด โปรดทำรายการอีกครั้ง"}
      />

      <FloatButton.BackTop
        className="custom-float-btn"
        icon={<ArrowUpOutlined style={{ color: "#fff" }} />}
        shape="square"
        style={{ backgroundColor: "#499D96 !important", color: "#fff" }}
      />
    </WithSidebar>
  );
};
